import { useSelector } from 'react-redux';
import { Route, Redirect } from 'react-router-dom';
import { getUserIsLoggedIn } from './../redux/auth';

function PrivateRoute({ children, redirectTo = '/login', ...routeProps }) {
  const isLoggedIn = useSelector(getUserIsLoggedIn);

  return (
    <Route {...routeProps}>
      {isLoggedIn ? children : <Redirect to={redirectTo} />}
    </Route>
  );
}

export default PrivateRoute;
